<template>
  <v-menu
    v-model="isOpen"
    class="profile-list-dialog"
    :close-on-click="true"
    :close-on-content-click="true"
    :disabled="!isLoggedIn"
  >
    <template #activator="{ props }">
      <v-btn
        v-show="isLoggedIn"
        text
        size="small"
        v-bind="props"
      >
        <v-icon
          class="mr-4"
          theme="dark"
          icon="fas fa-circle-user"
        />
        {{ displayname }}
      </v-btn>
    </template>

    <v-list>
      <ProfileDialog
        :profile-details="profileDetails"
        :close-profile-list="closeProfileList"
      />
      <SignoutDialog
        :sign-out="signOut"
        :close-profile-list="closeProfileList"
      />
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ProfileDialog from "./ProfileDialog.vue";
import SignoutDialog from "../signout-dialog/SignoutDialog.vue";

export default defineComponent({
  name: "ProfileListDialog",
  components: {
    ProfileDialog,
    SignoutDialog,
  },
  props: {
    profileListIsOpen: Boolean,
    profileDetails: String,
    isLoggedIn: Boolean,
    displayname: String,
    signOut: Function,
  },
  data() {
    return {
      isOpen: this.profileListIsOpen,
    };
  },
  methods: {
    closeProfileList() {
      this.isOpen = false;
    },
  },
});
</script>

<style>
.profile-list-dialog {
  z-index: 60;
}
</style>
